import React, { FC, ReactNode } from 'react';
import { ProCol, ProRow } from '../antd';
import classnames from 'classnames';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { SearchFormItemProps } from './index';
import { ColProps } from 'antd/lib/col';

export interface SearchFormFixedProps extends BaseSearchFormItemProps {
  /** 分组标题 */
  label?: ReactNode;
  /** 分组标题类名 */
  labelClassName?: string;
  /** 分组内容类名 */
  containerClassName?: string;
  /** 最外层容器类名 */
  className?: string;
  /** 每行显示多少个表单 */
  defaultLineNumber?: number;
  /** 每个Item的默认labelCol配置 */
  defaultLabelCol?: ColProps;
  /** 测试ID */
  testId?: string;
  children?: any;
}
/** 左右fixed布局 */
export const SearchFormFixed: FC<SearchFormFixedProps> = props => {
  const {
    children,
    form,
    span,
    offset,
    order,
    pull,
    push,
    defaultLineNumber,
    defaultLabelCol,
    label,
    labelClassName,
    containerClassName,
    className,
    testId,
    style,
  } = props;
  const classes = classnames('yb-form-group', labelClassName);
  const renderChildren = () => {
    let spanNumber: number | undefined = defaultLineNumber
      ? Math.floor(24 / defaultLineNumber)
      : undefined;
    return React.Children.map(children, child => {
      const childElement = child as React.FunctionComponentElement<
        SearchFormItemProps
      >;
      const { displayName } = childElement.type;
      if (displayName && displayName in SearchFormItemEnum) {
        if (displayName === SearchFormItemEnum.SearchFormTabs)
          return React.cloneElement(childElement, { form });
        const otherParams: any = {
          form,
          testId,
          span: childElement.props.span || spanNumber,
          labelCol: { ...defaultLabelCol, ...childElement.props.labelCol },
        };
        if (displayName === SearchFormItemEnum.SearchFormGroup || displayName === SearchFormItemEnum.SearchFormFixed) {
          otherParams.defaultLineNumber = childElement.props.defaultLineNumber || defaultLineNumber;
          otherParams.defaultLabelCol = childElement.props.defaultLabelCol || defaultLabelCol;
        }
        return React.cloneElement(childElement, otherParams);
      } else {
        console.error(
          'Warning: SearchForm has a child which is not a Item component',
        );
      }
    });
  };
  return (
    <ProCol
      className={className}
      span={span}
      offset={offset}
      order={order}
      pull={pull}
      push={push}
      style={style}
    >
      {label && (
        <ProCol span={24}>
          <div className={classes}>{label}</div>
        </ProCol>
      )}
      <ProRow gutter={24} className={containerClassName}>
        {renderChildren()}
      </ProRow>
    </ProCol>
  );
};
SearchFormFixed.displayName = SearchFormItemEnum.SearchFormFixed;

export default SearchFormFixed;
